import SurveysScreen from './SurveysScreen';

export default SurveysScreen;
